import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';

import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import { Button } from '~/components/ui/button';
import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';
import { isMobileResolution } from '~/utils/common';

import AnonMobileSideBar from '../../components/organisms/anon-sidebar/AnonMobileSideBar';

import { TERMS_DEFINITIONS, TERMS_RESTRICTIONS } from './constans';

export default function TermsConditions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openBar, setOpenBar] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <AnonMobileSideBar open={openBar} setOpen={setOpenBar}>
        <>
          <HeaderPublic />
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'trasparent',
            }}
          >
            <Box
              sx={{
                top: 0,
                height: '30%',
                width: '100%',
                position: 'absolute',
                zIndex: 0,
              }}
            />
            <Box
              sx={{
                pl: isMobileResolution ? 0 : 2,
                pr: isMobileResolution ? 0 : 2,
                zIndex: 1,
                pt: isMobileResolution ? 6 : 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: 48,
                  letterSpacing: -0.96,
                  lineHeight: '116%',
                  pt: 10,
                  '@media (max-width: 500px)': {
                    fontSize: 40,
                  },
                }}
              >
                {t('terms:title')}
              </Typography>
              <Typography
                sx={{
                  pt: 2,
                  pb: 10,
                  textAlign: 'center',
                  fontSize: 16,
                  letterSpacing: -0.32,
                  lineHeight: '175%',
                  color: COLORS.black06,
                }}
              >
                {t('terms:lastUpdate')}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: COLORS.white, width: '100%', height: 'auto', pt: 10, alignItems: 'center' }}>
              <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:general:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:general:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:general:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:general:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:license:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:license:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:license:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:license:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:definitions:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:definitions:0')}
                </Typography>
                <Box component="ul" sx={{ pl: 2 }}>
                  {TERMS_DEFINITIONS.map((item, index) => (
                    <Box component="li" key={index} sx={{ mb: 1.5 }}>
                      <Typography variant="body1" component="span" sx={{ color: COLORS.black06 }}>
                        {t(`toc:definitions:item:${index}`)}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:restrictions:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:restrictions:0')}
                </Typography>
                <Box component="ul" sx={{ pl: 2, listStyleType: 'disc', m: 0 }}>
                  {TERMS_RESTRICTIONS.map((item, index) => (
                    <Box component="li" key={index} sx={{ mb: 1.5 }}>
                      <Typography variant="body1" component="span" sx={{ color: COLORS.black06 }}>
                        {t(`toc:restrictions:item:${index}`)}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:return:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:return:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:return:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:return:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:suggest:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:suggest:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:suggest:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:consent:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:consent:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:links:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:links:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:cookies:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:cookies:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:change:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:change:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:change:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:modify:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:modify:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:updates:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:updates:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:updates:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:updates:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:ownership:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:ownership:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:service:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:service:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:service:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:service:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:termination:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:termination:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:termination:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:termination:2')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:termination:3')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:termination:4')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:copyright:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:copyright:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:indemnification:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:indemnification:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:warranties:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:warranties:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:warranties:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:warranties:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:limit:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:limit:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:limit:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:limit:2')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:sever:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:sever:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:sever:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:waiver:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:waiver:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:waiver:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:amendments:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:amendments:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:amendments:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:entire:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:entire:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:entire:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:updatesTerm:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:updatesTerm:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:intellectual:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:intellectual:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:arbitrate:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:arbitrate:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:dispute:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:dispute:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:bindArb:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:bindArb:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:subprivacy:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:subprivacy:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:promotions:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:promotions:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:promotions:1')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:typogrerror:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:typogrerror:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:miscell:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:miscell:0')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:disclaimer:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:disclaimer:0')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:disclaimer:1')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:disclaimer:2')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:disclaimer:3')}
                </Typography>

                <Box sx={{ mt: 6 }} />

                <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
                  {t('toc:contactus:title')}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                  {t('toc:contactus:0')}
                </Typography>
                <Box component="ul" sx={{ pl: 2, listStyleType: 'disc', m: 0 }}>
                  {[0].map((index) => (
                    <Box component="li" key={index} sx={{ mb: 1.5 }}>
                      <Typography variant="body1" component="span" sx={{ color: COLORS.black06 }}>
                        {t('toc:contactus:1')}
                        <Link
                          href="mailto:support@qrbrain.io"
                          sx={{
                            color: COLORS.black06,
                            textDecorationColor: COLORS.black06,
                            textDecorationThickness: '1px',
                            '&:hover': {
                              color: COLORS.black06,
                              textDecorationColor: COLORS.black06,
                            },
                          }}
                        >
                          support@qrbrain.io
                        </Link>
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Container>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, mb: 10 }}>
                <Button
                  sx={{
                    backgroundColor: COLORS.purple,
                    color: COLORS.white,
                    padding: '8 22px',
                    mt: 1,
                    '&:hover': {
                      color: COLORS.black,
                    },
                    '&.Mui-disabled': {
                      backgroundColor: COLORS.primaryGray,
                    },
                  }}
                  onClick={() => navigate(PATH.LOGIN)}
                >
                  {t('terms:button')}
                </Button>
              </Box>
            </Box>
          </Box>
          <FooterPublic />
        </>
      </AnonMobileSideBar>
    </>
  );
}
